module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('b-modal', {
    attrs: {
      "active": _vm.isComponentModalActive,
      "has-modal-card": ""
    },
    on: {
      "update:active": function($event) {
        _vm.isComponentModalActive = $event
      }
    }
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head bg-primary"
  }, [_c('span', {
    staticClass: "modal-card-title",
    staticStyle: {
      "color": "white"
    }
  }, [_c('span', [_vm._v("FEEDBACK")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right drag_pointer"
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("apps")])], 1)])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('h3', [_vm._v("\n                  Comments\n                ")]), _vm._v(" "), _vm._l((_vm.userComments.slice(0, 5)), function(comment, idx) {
    return _c('span', {
      key: idx
    }, [_c('label', [_vm._v(_vm._s(comment.fullName) + " -- "), _c('em', [_vm._v(_vm._s(comment.organization))])]), _vm._v(" "), _c('p', {
      staticClass: "black--text"
    }, [_vm._v(_vm._s(comment.comment))]), _vm._v(" "), _c('br')])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "column is-6 form"
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.postComment()
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Full Name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fullName),
      expression: "fullName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "fullName",
      "required": ""
    },
    domProps: {
      "value": (_vm.fullName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fullName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "pwd"
    }
  }, [_vm._v("Organization:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization),
      expression: "organization"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "organization",
      "required": ""
    },
    domProps: {
      "value": (_vm.organization)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.organization = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment),
      expression: "comment"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3",
      "placeholder": "Type your comment here ...",
      "id": "comment",
      "required": ""
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("How has your experience on this platform been")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("It was easy to navigate and find what I needed")]), _vm._v(" "), _c('li', [_vm._v("It took me sometime but I found what I needed")]), _vm._v(" "), _c('li', [_vm._v("It took me a very long time to find what I needed")]), _vm._v(" "), _c('li', [_vm._v("I couldn't find what I needed")]), _vm._v(" "), _c('li', [_vm._v("I don't even understand the platform")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "dark": "",
      "color": "blue"
    }
  }, [_vm._v("Submit")])], 1)])])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('button', {
    staticClass: "button is-danger pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isComponentModalActive = false
      }
    }
  }, [_vm._v("CLOSE")])])])])]), _vm._v(" "), _c('v-speed-dial', {
    attrs: {
      "top": false,
      "bottom": true,
      "right": true,
      "left": false,
      "fixed": true,
      "absolute": false,
      "direction": 'top',
      "open-on-hover": false,
      "transition": _vm.transition
    },
    model: {
      value: (_vm.fab),
      callback: function($$v) {
        _vm.fab = $$v
      },
      expression: "fab"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "indigo darken-2",
      "dark": "",
      "fab": "",
      "ripple": false,
      "id": "comments-button"
    },
    on: {
      "click": function($event) {
        _vm.loadCommentModal(_vm.isComponentModalActive)
      }
    },
    slot: "activator",
    model: {
      value: (_vm.fab),
      callback: function($$v) {
        _vm.fab = $$v
      },
      expression: "fab"
    }
  }, [_c('v-icon', [_vm._v("fas fa-comment")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7316aaca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboards/car/components/comments.vue
// module id = 970
// module chunks = 0